import { Button, Result } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import './index.less';
import getMoney from '@/utils/getMoney';

const titleMap = {
  '01': '已授信成功',
  '02': '授信失败',
  '03': '预授信成功',
};

const defaultTitle = '您的申请已提交，您可以在“我的申请”查看最新进度情况';

export default function Index() {
  const Navigate = useNavigate();
  const { state } = useLocation();
  const {
    decisionResult, recommentAmt, reason, dueDate, appDate,
  } = state || {};
  const curMoneyUnit = getMoney(recommentAmt / 10000);

  function toHome() {
    Navigate('/home');
  }

  const subTitleMap = {
    '01': `您的授信额度为${curMoneyUnit?.num}${curMoneyUnit?.unit || '元'}，授信有效期为${appDate}至${dueDate}。`,
    '02': `对不起，您不符合授信要求。具体原因:${reason}`,
    '03': `您的预授信额度为${curMoneyUnit?.num}${curMoneyUnit?.unit || '元'}`,
  };

  return (
    <div className="result">
      <div className="border" />
      <div className="result__con">
        <div>
          <Result
            status={decisionResult !== '02' ? 'success' : 'error'}
            title={state ? titleMap[decisionResult] : defaultTitle}
            subTitle={state && subTitleMap[decisionResult]}
            extra={[
              <Button type="primary" key="console" onClick={toHome}>
                确定
              </Button>,
            ]}
          />
        </div>
      </div>
    </div>
  );
}
